(() => {
  'use strict';
  const configNode = document.getElementById('ff-ring-sizer-policy-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  if (config.countryCode === 'GB') return;
  const allowedForms = new WeakSet();
  let checking = false;
  let cartRefreshTimer;

  function isSizerItem(item) {
    const property = item.properties && item.properties['Ring size'];
    return `${item.variant_title || ''} ${property || ''}`.toLowerCase().includes('ring sizer');
  }

  function hasSizerRequest(cart) {
    return Array.isArray(cart.items) && cart.items.some(isSizerItem);
  }

  async function readCart() {
    const response = await fetch(`${config.cartUrl}.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart read failed');
    return response.json();
  }

  function syncCartControls(cart) {
    const root = document.querySelector('[data-section-type="cart"]');
    if (!root) return;
    const blocked = hasSizerRequest(cart);
    root.querySelectorAll('.cart-checkout-button').forEach((button) => {
      if (blocked) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-ff-sizer-disabled', '');
      } else if (button.hasAttribute('data-ff-sizer-disabled')) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.removeAttribute('data-ff-sizer-disabled');
      }
    });
    root.querySelectorAll('.additional-checkout-buttons').forEach((buttons) => {
      if (blocked && !buttons.hidden) {
        buttons.hidden = true;
        buttons.setAttribute('data-ff-sizer-hidden', '');
      } else if (!blocked && buttons.hasAttribute('data-ff-sizer-hidden')) {
        buttons.hidden = false;
        buttons.removeAttribute('data-ff-sizer-hidden');
      }
    });
    const oldNotice = root.querySelector('[data-ff-cart-sizer-notice]');
    if (!blocked) {
      if (oldNotice) oldNotice.remove();
      return;
    }
    if (oldNotice) return;
    const notice = document.createElement('div');
    notice.className = 'row-half-space';
    notice.setAttribute('role', 'alert');
    notice.setAttribute('data-ff-cart-sizer-notice', '');
    const heading = document.createElement('h2');
    heading.textContent = config.cartHeading;
    const message = document.createElement('p');
    message.textContent = config.cartMessage;
    const links = document.createElement('ul');
    cart.items.filter(isSizerItem).forEach((item) => {
      const row = document.createElement('li');
      const link = document.createElement('a');
      const url = new URL(item.url, window.location.origin);
      url.searchParams.delete('variant');
      link.href = url.pathname;
      link.textContent = `${config.chooseSizeLabel}: ${item.product_title || item.title}`;
      row.append(link);
      links.append(row);
    });
    notice.append(heading, message, links);
    const form = root.querySelector('form');
    if (form) form.before(notice);
  }

  function refreshCartControls() {
    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(() => {
      readCart().then(syncCartControls).catch(() => {});
    }, 150);
  }

  const cartRoot = document.querySelector('[data-section-type="cart"]');
  if (cartRoot) {
    const cartObserver = new MutationObserver((records) => {
      const itemsChanged = records.some((record) => {
        if (record.target.closest && record.target.closest('.cart-items')) return true;
        return [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1 && (node.matches('.cart-item, .cart-items') || node.querySelector('.cart-item, .cart-items')));
      });
      if (itemsChanged) refreshCartControls();
    });
    cartObserver.observe(cartRoot, { childList: true, subtree: true });
    refreshCartControls();
  }

  async function checkThenContinue(continueCheckout) {
    if (checking) return;
    checking = true;
    try {
      const cart = await readCart();
      syncCartControls(cart);
      if (hasSizerRequest(cart)) {
        window.alert(config.cartMessage);
        window.location.assign(config.cartUrl);
        return;
      }
      continueCheckout();
    } catch (_) {
      window.alert(config.checkFailedMessage);
      window.location.assign(config.cartUrl);
    } finally {
      checking = false;
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !/\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkThenContinue(() => window.location.assign(url.href));
  }, true);

  window.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (allowedForms.has(form)) {
      allowedForms.delete(form);
      return;
    }
    const submitter = event.submitter;
    const action = new URL(form.action, window.location.href);
    const checkoutAction = action.origin === window.location.origin && /\/(?:checkout|checkouts)(?:\/|$)/.test(action.pathname);
    if ((!submitter || submitter.name !== 'checkout') && !checkoutAction) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkThenContinue(() => {
      allowedForms.add(form);
      if (submitter) form.requestSubmit(submitter);
      else form.requestSubmit();
    });
  }, true);
})();
